import { nanoid } from 'nanoid';
import { removeExt } from 'pano-utils';
import type { Files } from '@types';
import { sendError } from '@components/Noti';
import getFileMd5 from '@utils/getFileMd5';
import domain from '../../domain';
import { $libUploadingPVideo } from '../../stores/libUploading';
import { taskCreateApi } from './taskApis';
import panoVideoUpload from './panoVideoUpload';
import refetchLibSpace from '../../utils/refetchLibSpace';

interface Params {
  id: string;
  uploadingId: string;
  albumId: number;
  file: File;
}

const taskFx = domain.effect(
  async ({ id, file, albumId, uploadingId }: Params) => {
    const data = await taskCreateApi({
      fileId: id,
      name: removeExt(file.name),
      size: file.size,
      duration: 0,
      width: 0,
      height: 0,
      albumId,
    });
    await panoVideoUpload(file, data, (progress) => {
      $libUploadingPVideo.api.progress({ id: uploadingId, progress });
    });
    $libUploadingPVideo.api.libId({ id: uploadingId, libId: data.materialId });
    $libUploadingPVideo.api.progress({ id: uploadingId, progress: '制作中' });
    refetchLibSpace();
  }
);

taskFx.fail.watch(({ params, error }) => {
  $libUploadingPVideo.api.remove(params.id);
  sendError(error.message);
});

const panoVideoTask = domain.effect(
  async ({ files, albumId }: { albumId: number; files: Files }) => {
    for (let i = 0; i < files.length; i++) {
      const uploadingId = `u_${nanoid()}`;
      const file = files[i];
      $libUploadingPVideo.api.add({
        id: uploadingId,
        name: removeExt(file.name),
      });
      const id = await getFileMd5(file);
      taskFx({ albumId, file, id, uploadingId });
    }
  }
);

panoVideoTask.failData.watch((e) => {
  sendError(e.message);
});

export default panoVideoTask;
